import React from "react";

const DBasic = (parent) => {
    // console.log(parent)
    const record = parent.record;
    if(!record.category_name)
        return '';
    return (
        <div>
            <div className="department-info">
                <div className="department-icon-cate">
                    <div className="icon-obj icon-cate-1"/>
                </div>
                <div className="department-cate"/>
                <div className="department-name"> {record.up_category_name} • {record.category_name}</div>
            </div>
        </div>
    );
};

export default DBasic;
